module.exports = __webpack_public_path__ + "9da7284294715417dc1fed4d483e0ccd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-o.png
// module id = 2082
// module chunks = 4